import type { InferOutput } from "valibot";
import { object } from "valibot";
import { MAX_NUMBER_XL, MAX_NUMBER_XL_NEGATIVE, NUMBER_CONDITION_KEYS } from "../../constants";
import type { VariableDefinition } from "../Variable";
import { initVariable, VariableBaseSchema } from "../Variable";
import { decimalValue, require } from "../../utils/validation/base";
import { keyFromSelector } from "i18next";

const Schema = object({
  ...VariableBaseSchema.entries,
  defaultValue: require(decimalValue(MAX_NUMBER_XL_NEGATIVE, MAX_NUMBER_XL)),
});

export type NumberVariableType = InferOutput<typeof Schema>;

const NumberVariable: VariableDefinition<NumberVariableType> = {
  type: "number",
  icon: "listNumber",
  schema: Schema,
  ruleConditionBehaviour: {
    variant: "text",
    keys: NUMBER_CONDITION_KEYS,
  },
  titleKey: keyFromSelector(($) => $.NUMBER_VARIABLE_LABEL),
};

export default initVariable(NumberVariable);
